import type { IconProps } from '../types/IconProps.ts';
export const ArrowRightToLine: IconProps = {
    name: 'ArrowRightToLine',
    children: [
        `<path d="M3 12.05h12M21 5v14M11 6l5.65 5.65c.2.2.2.5 0 .7L11 18" />`,
    ]
};